import React from 'react';
import PropTypes from 'prop-types';

import Dropzone from 'react-dropzone';
import api from './api';
import Attachment from './attachment';
import AttachmentModal from './modal';

import './styles.scss';
import { without } from 'lodash';
import { Card } from 'react-bootstrap-5';

class AttachmentsPanel extends React.Component {
  static propTypes = {
    attachable: PropTypes.shape({
      id: PropTypes.number.isRequired,
      type: PropTypes.string.isRequired
    }).isRequired,
    attachments: PropTypes.array.isRequired,
    limit: PropTypes.number,
    path: PropTypes.string.isRequired,
    readOnly: PropTypes.bool
  }

  static defaultProps = {
    limit: 3
  }

  state = {
    attachments: [...this.props.attachments].reverse(),
    showModal: false
  }

  openModal = () => {
    this.setState({ showModal: true });
  }

  closeModal = () => {
    this.setState({ showModal: false });
  }

  handleAttachmentDeleted = (attachment) => {
    this.setState(({ attachments }) => ({
      attachments: without(attachments, attachment)
    }));
  }

  handleUpload = (files) => {
    if (files.length === 0) {
      return;
    }

    const file = files.shift();
    api.createAttachment(this.props.path, this.props.attachable, file).then((attachment) => {
      this.setState(({ attachments }) => ({
        attachments: [attachment].concat(attachments)
      }));
    });
  }

  render() {
    return (
      <Card className="attachments-panel">
        <Card.Body>
          <div className="fw-bold">Attachments</div>
          {this.renderAttachments()}
          {this.renderActions()}
        </Card.Body>

        <AttachmentModal
          attachments={this.state.attachments}
          path={this.props.path}
          readOnly={this.props.readOnly}
          show={this.state.showModal}
          onAttachmentDeleted={this.handleAttachmentDeleted}
          onClose={this.closeModal}
        />
      </Card>
    );
  }

  renderAttachments() {
    const { attachments } = this.state;

    if (attachments.length === 0) {
      return <div className="text-muted my-2"><i>No attachments</i></div>;
    }

    const children = [];
    for (let i = 0; i < Math.min(attachments.length, this.props.limit); i++) {
      children.push(
        <div className="d-flex align-items-center justify-content-between attachment-row" key={attachments[i].id}>
          <Attachment attachment={attachments[i]} />
        </div>
      );
    }

    return (
      <div className="d-flex flex-column gap-2 my-2">
        {children}
      </div>
    );
  }

  renderActions() {
    const links = [];

    if (!this.props.readOnly) {
      links.push(
        <Dropzone key="add-new" onDrop={this.handleUpload}>
          {({ getRootProps, getInputProps }) => (
            <a className="clickable" {...getRootProps()}>
              ADD NEW
              <input {...getInputProps()} />
            </a>
          )}
        </Dropzone>
      );
    }

    if (this.state.attachments.length > 0) {
      links.push(
        <a
          className="clickable"
          key="view-all"
          name="modal-link"
          onClick={this.openModal}
        >
          VIEW ALL
        </a>
      );
    }

    return <div className="d-flex pt-2 justify-content-around border-top">{links}</div>;
  }
}

export default AttachmentsPanel;
